import { APP_PERMISSIONS } from '@exam-management/permissions';
import { PermissionGuard } from '@shared/permissions';
import { Outlet } from 'react-router-dom';

export default function SingleQuestionActivityLogLayout() {
  return (
    <PermissionGuard
      requiredPermission={[
        APP_PERMISSIONS.QBANK.QUESTION.VIEW,
        APP_PERMISSIONS.QBANK.AUDIT_LOG.VIEW,
      ]}
    >
      <Outlet />
    </PermissionGuard>
  );
}
